import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import Close from '@mui/icons-material/Close'
import {
  StyledContentHeader,
  StyledBoxContainer,
  StyledTypography,
} from './Styled'
import { downloadFile, downloadAllFiles } from './events'
import { shallowEqual, useSelector } from 'react-redux'

import DownloadIcon from '@mui/icons-material/Download'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { StyledContent, StyledDrawer, StyledHeadLabel } from '../Styled'

const StudyPapersDrawer = ({ isOpen, onCloseDrawer }) => {
  const data = useSelector((state) => state.registration.data, shallowEqual)
  const courseDocument = _.get(data, 'courseDocumentDatas', [])
  const haveDownloadable = courseDocument
    .filter((item) => item.type == 'UploadFile')
    .some((item) => item.canDownload)

  return (
    <StyledDrawer open={isOpen} onClose={onCloseDrawer}>
      <StyledContent>
        <StyledHeadLabel>
          <Box id="header">
            <Typography variant="h5">เอกสารการเรียน</Typography>
            <IconButton
              data-testid="btn-close-drawer"
              color="primary"
              component="span"
              onClick={onCloseDrawer}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider />
        </StyledHeadLabel>
        <StyledContentHeader>
          <Typography>ไฟล์</Typography>
          <Button
            data-testid="btn-download-all"
            onClick={() => downloadAllFiles(courseDocument)}
            size="m"
            disabled={!haveDownloadable}
          >
            ดาวน์โหลดทั้งหมด
          </Button>
        </StyledContentHeader>

        {courseDocument.map((item, index) => (
          <>
            {item.type === 'Link' && <LinkItem index={index} item={item} />}

            {item.type === 'UploadFile' && (
              <StyledBoxContainer key={index}>
                <Box>
                  <StyledTypography variant="body1">
                    {item.name}
                  </StyledTypography>
                  <Typography variant="body2" color="text.secondary">
                    ประเภท: E-Content
                  </Typography>
                  {item.isDownload && (
                    <Typography variant="caption" color="text.secondary">
                      *อนุญาตผู้เรียนดาวน์โหลด
                    </Typography>
                  )}
                </Box>
                <Button
                  disabled={!_.get(item, 'canDownload', false)}
                  data-testid="btn-download-file"
                  variant="outlined"
                  sx={{ minWidth: '38px' }}
                  size="s"
                  onClick={() => downloadFile(item.link, item.name)}
                >
                  <DownloadIcon />
                </Button>
              </StyledBoxContainer>
            )}
          </>
        ))}
      </StyledContent>
    </StyledDrawer>
  )
}

export default StudyPapersDrawer

export const LinkItem = ({ index, item }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false)
      }, 2000)
    }
  }, [open])

  return (
    <StyledBoxContainer key={index}>
      <Box>
        <Typography variant="body1">{item.name}</Typography>
        <Typography variant="body2" color="primary">
          {_.get(item, 'link', '').slice(0, 25) + '...'}
        </Typography>
      </Box>
      <Tooltip
        PopperProps={{ disablePortal: true }}
        onClose={() => setOpen(false)}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={<Typography variant="tooltip">คัดลอกแล้ว</Typography>}
        arrow
        placement="bottom"
      >
        <Button
          data-testid="btn-copy"
          variant="outlined"
          sx={{ minWidth: '38px' }}
          size="s"
          onClick={() => {
            setOpen(true)
            navigator.clipboard.writeText(item.link)
          }}
        >
          <ContentCopyIcon />
        </Button>
      </Tooltip>
    </StyledBoxContainer>
  )
}
